import {
	getApiKeys,
	getBilling,
	getBillingApiAnalyticsSummary,
	getBillingApiAnalyticsTimeseries,
	getBillingApiRequestLogs,
	getBillingUsage
} from '@repo/api-portal-sdk/gen'
import { queryOptions } from '@tanstack/react-query'
import { makeQueryKeys } from '@/lib/query-keys'

const API_KEY_PAGE_SIZE = 5
const RECENT_LOG_LIMIT = 6
const TIMESERIES_RANGE = '7d' as const

export function dashboardApiKeysQueryOptions(
	filters: { page: number; status: 'active' | 'expired' | 'revoked' } = {
		page: 1,
		status: 'active'
	}
) {
	return queryOptions({
		queryKey: makeQueryKeys.apiKeys.list(filters),
		queryFn: ({ signal }) =>
			getApiKeys({
				query: { limit: API_KEY_PAGE_SIZE, ...filters },
				signal
			}).then((response) => response.data)
	})
}

export function dashboardUsageQueryOptions() {
	return queryOptions({
		queryKey: makeQueryKeys.billing.usage(),
		queryFn: ({ signal }) =>
			getBillingUsage({ signal }).then((response) => response.data.data)
	})
}

export function dashboardBillingQueryOptions() {
	return queryOptions({
		queryKey: makeQueryKeys.billing.subscription(),
		queryFn: ({ signal }) =>
			getBilling({ signal }).then((response) => response.data.data)
	})
}

export function dashboardAnalyticsSummaryQueryOptions() {
	return queryOptions({
		queryKey: makeQueryKeys.billing.analytics.summary(),
		queryFn: ({ signal }) =>
			getBillingApiAnalyticsSummary({ signal }).then(
				(response) => response.data.data
			)
	})
}

export function dashboardTimeseriesQueryOptions() {
	return queryOptions({
		queryKey: makeQueryKeys.billing.analytics.timeseries(TIMESERIES_RANGE),
		queryFn: ({ signal }) =>
			getBillingApiAnalyticsTimeseries({
				query: { range: TIMESERIES_RANGE },
				signal
			}).then((response) => response.data.data)
	})
}

export function dashboardLogsQueryOptions() {
	return queryOptions({
		queryKey: makeQueryKeys.billing.analytics.logs(RECENT_LOG_LIMIT),
		queryFn: ({ signal }) =>
			getBillingApiRequestLogs({
				query: { limit: RECENT_LOG_LIMIT },
				signal
			}).then((response) => response.data.data)
	})
}
